export enum FoundationDateRangeFilter {
  'ALL TIME' = 'all',
  'CURRENT YEAR' = 'this_year',
  'LAST YEAR' = 'last_year',
}
